import { apiGet } from '@/store/api';
import { ProformaEmailTemplate, ProformaEmailTemplateItem } from '@/types/ProformaTypes';

export async function getProformaEmailTemplates(agencyId: string | number, isPortcallTab: boolean) {
  const templates = (await apiGet(`mail/templates/proforma/${agencyId}/${isPortcallTab}`)) as ProformaEmailTemplate[];

  const templatesWithEventNames: ProformaEmailTemplateItem[] = templates.map((item) => ({
    ...item,
    btnType: 'CUSTOM',
    disabled: false,
    caption: item.TITLE,
    eventName: 'createEmailFromTemplateClick',
    icon: 'mdi-file-outline',
  }));

  return templatesWithEventNames;
}
